/**
 * GriffinNotifier class definition for webPOS.  Used to interface with
 * the Stencil/Griffin app to display notifications in the native header.
 *
 * Copyright 2014 LightSpeed Retail. All rights reserved.
 * Created by kevinford on 15-02-03.
 */
$(() => {
  function GriffinNotifier() {
    window.StencilWebAPI.NotifierBase.call(this);
  }
  GriffinNotifier.prototype = Object.create(window.StencilWebAPI.NotifierBase.prototype);
  GriffinNotifier.prototype.constructor = GriffinNotifier;

  /**
   * Called by webPOS to show a native notification in the stencil application.
   *
   * @param notification [Object]  - A notification object with message, type,
   *                                  and optional icon key/values.
   * (required) message : [String] - A string message
   * (required) type    : [String] - The type of notification
   * (optional) icon    : [String] - An icon to show.  The icon is infered from the
   *                                 type if not set in the provided object.
   * (optional) duration: [Number] - Duration to show message.
   **/
  GriffinNotifier.prototype.showStencilNotification = function(notification) {
    var stencilNotification = new window.StencilWebAPI.GriffinNotification(notification);
    this._stencilShowNotification(stencilNotification);
  };
  window.GriffinNotifier = GriffinNotifier;
});
